export const HOME_PAGE = "home"
export const BECOME_A_MODEL_PAGE = "become_a_model"
export const CONTACTS_PAGE = "contacts"
export const WOMEN_PAGE = "women"
export const MEN_PAGE = "men"
